//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import { mapMutations } from "vuex";
export default {
  name: "CPIS",
  data() {
    return {
      defaultJson: {
        "Tracheal Secretions": "痰液",
        Culture3: "致病菌与 Gram 染色所见一致（中等/大量）",
        "> 240 or ARDS": "> 240 或 ARDS",
        "White Cell Count": "白细胞计数",
        "WCC (short)": "< 4 或 > 11 x 10⁹/L + 杆状核",
        "Culture2 (short)": "中等或大量",
        "36.5 - 38.4 °C": "36.5 - 38.4 °C",
        "<4 or >11 G/L + bands": "< 4 或 > 11 x 10⁹/L + 杆状核中性粒细胞",
        Culture0: "培养无致病菌生长或见极少或少量致病菌",
        "Highly suggestive of VAP": "高度提示 VAP",
        "Abundant + purulent": "大量 + 脓性",
        "Progression0 (short)": "影像学无加重",
        "Infiltrate on Chest X-ray": "胸片浸润灶",
        "Radiographic progression (CHF and ARDS excluded)":
          "影像学进展（已排除慢性心衰和 ARDS）",
        None: "无",
        "38.5 - 38.9 °C": "38.5 - 38.9 °C",
        Diffuse: "弥漫",
        "Chest X-ray": "胸片",
        Culture2: "培养见中等或大量致病菌",
        "Culture3 (short)": "与 Gram 染色一致（+++）",
        Rare: "少量",
        "<4 or >11 G/L": "< 4 或 > 11 x 10⁹/L",
        "Pulmonary Infiltrates": "肺部浸润",
        Culture: "培养",
        "Culture0 (short)": "未见或极少数细菌",
        "< 36 or > 39 °C": "< 36 或 > 39 °C",
        Abundant: "大量",
        "No radiographic progression": "无影像学进展",
        Temperature: "体温",
        "PaO₂ / FiO₂": "PaO₂ / FiO₂",
        Progression: "进展",
        "≤ 240 and no ARDS": "≤ 240 且无 ARDS",
        Culture1: "致病菌与 Gram 染色所见一致（极少/少量）",
        "4 - 11 Giga/L": "4 - 11 x 10⁹/L",
        Localized: "局部",
        "Culture1 (short)": "与 Gram 染色一致（+）",
        "Culture of tracheal aspirate": "痰培养",
        "Progression1 (short)": "影像学加重",
      },
      form: {
        trachealSecretions: "",
        infiltratesCXR: "",
        temperature: "",
        wcc: "",
        paO2FiO2: "",
        progressionInfiltrate: "",
        culture: "",
      },
      hasScore: false,
      disabled: false,
      dataList1: [
        { value: "0", name: "少量" },
        { value: "1", name: "大量" },
        { value: "2", name: "大量 + 脓性" },
      ],
      dataList2: [
        { value: "0", name: "无" },
        { value: "1", name: "弥漫" },
        { value: "2", name: "局部" },
      ],
      dataList3: [
        { value: "0", name: "36.5 - 38.4 °C" },
        { value: "1", name: "38.5 - 38.9 °C" },
        { value: "2", name: "< 36 or > 39 °C" },
      ],
      dataList4: [
        { value: "0", name: "4 - 11 x 10⁹/L" },
        { value: "1", name: "< 4 或 > 11 x 10⁹/L" },
        {
          value: "2",
          name: "< 4 或 > 11 x 10⁹/L + 杆状核中性粒细胞",
          shortName: "< 4 或 > 11 x 10⁹/L + 杆状核",
        },
      ],
      dataList5: [
        { value: "0", name: "> 240 或 ARDS" },
        { value: "1", name: "≤ 240 且无 ARDS" },
      ],
      dataList6: [
        { value: "0", name: "无影像学进展", shortName: "影像学无加重" },
        {
          value: "2",
          name: "影像学进展（已排除慢性心衰和 ARDS）",
          shortName: "影像学加重",
        },
      ],
      dataList7: [
        {
          value: "0",
          name: "培养无致病菌生长或见极少或少量致病菌",
          shortName: "未见或极少数细菌",
          index: "0",
        },
        {
          value: "1",
          name: "致病菌与 Gram 染色所见一致（极少/少量）",
          shortName: "与 Gram 染色一致（+）",
          index: "1",
        },
        {
          value: "1",
          name: "培养见中等或大量致病菌",
          shortName: "中等或大量",
          index: "2",
        },
        {
          value: "2",
          name: "致病菌与 Gram 染色所见一致（中等/大量）",
          shortName: "与 Gram 染色一致（+++）",
          index: "3",
        },
      ],
    };
  },
  created() {
    this.hideLoad();
  },
  methods: {
    ...mapMutations(["hideLoad"]),
  },
  computed: {
    /** 计算公式结果 */
    score() {
      let self = this;
      let form = JSON.parse(JSON.stringify(self.form));
      let flag = true;
      for (const key in form) {
        if (form.hasOwnProperty(key)) {
          if (!form[key]) {
            flag = false;
          } else {
            form[key] = Number(form[key]);
          }
        }
      }
      if (!flag) {
        self.hasScore = false;
        return "";
      } else {
        // trachealSecretions + infiltratesCXR + temperature + wcc + paO2FiO2 + (progressionInfiltrate ? progressionInfiltrate : 0) + (culture ? culture : 0)
        let result =
          form.trachealSecretions +
          form.infiltratesCXR +
          form.temperature +
          form.wcc +
          form.paO2FiO2 +
          (form.progressionInfiltrate ? form.progressionInfiltrate : 0) +
          (form.culture ? form.culture : 0);
        self.hasScore = true;
        return String(result);
      }
    },
  },
};



// WEBPACK FOOTER //
// ./src/pages/formulas/ID/CPIS.vue